import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Spoiler from '../../../../../../../components/Spoiler'
import Field from '../../../../../../../components/Form/Field'

import { SPEND_LIFETIME } from '../../../fields'
import {
  MIN_SPEND_TARGET_DAILY,
  MIN_SPEND_TARGET_LIFETIME,
  SPEND_CAP_DAILY,
  SPEND_CAP_LIFETIME
} from '../../../../../../Multiplatform/LineItemForms/fields'

import { selectedFacebookAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import useStyles from '../../../../../../../styles/common/drawerForms'

const SpendContent = ({ formik, spendType }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const { currency_symbol } = useSelector(selectedFacebookAdAccountSelector)

  if (spendType) {
    const spendTypeMessage = spendType === SPEND_LIFETIME ? 'Lifetime' : 'Daily'
    const minSpendFieldName = spendType === SPEND_LIFETIME ? MIN_SPEND_TARGET_LIFETIME : MIN_SPEND_TARGET_DAILY
    const maxSpendFieldName = spendType === SPEND_LIFETIME ? SPEND_CAP_LIFETIME : SPEND_CAP_DAILY

    return (
      <div className={classes.sectionSpoiler}>
        <Spoiler title={t('View advanced budget options')}>
          <div className={classes.sectionItem}>
            <div className={classes.sectionSubtitle}>{t(`${spendTypeMessage} Minimum or Maximum Spend`)}</div>
            <p>{t('You can set either a minimum or maximum spend on this ad set, or both.')}</p>
            <p>
              {t(
                'This will force Facebook to spend at least the amount you set in the case of a minimum spend, or it won’t spend more than the maximum spend.'
              )}
            </p>
            <Field
              type="number"
              formik={formik}
              name={minSpendFieldName}
              placeholder={t(`${spendTypeMessage} minimum spend`)}
              symbol={currency_symbol}
              autoComplete="off"
            />
            <Field
              type="number"
              formik={formik}
              name={maxSpendFieldName}
              placeholder={t(`${spendTypeMessage} maximum spend`)}
              symbol={currency_symbol}
              autoComplete="off"
            />
          </div>
        </Spoiler>
      </div>
    )
  }

  return null
}

export default SpendContent
